import React from 'react';
import OrderList from '../components/OrderList';

const OrdersPage = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-3xl font-bold">Quản lý Order</h1>
      <OrderList />
    </div>
  );
};

export default OrdersPage; 